import React, { useState } from 'react';
import { Input } from 'baseui/input';
import { Button } from 'baseui/button';
import { FormControl } from 'baseui/form-control';

export default function MfaVerifyStep({ onVerify, onCancel, loading, error, cancelLabel = 'Back' }) {
  const [code, setCode] = useState('');

  const submit = (e) => {
    e.preventDefault();
    onVerify(code.replace(/\s/g, ''));
  };

  return (
    <form onSubmit={submit} className="auth-mfa-panel">
      <h2 style={{ margin: '0 0 8px', fontSize: '1.25rem' }}>Two-factor authentication</h2>
      <p style={{ color: '#64748b', fontSize: '0.9375rem', marginBottom: 16 }}>
        Enter the 6-digit code from your authenticator app.
      </p>
      <FormControl label="Verification code">
        <Input
          value={code}
          onChange={(e) => setCode(e.target.value)}
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder="000000"
          maxLength={8}
          autoFocus
        />
      </FormControl>
      {error && <p role="alert" style={{ color: '#c92a2a', fontSize: 14 }}>{error}</p>}
      <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
        <Button type="submit" isLoading={loading} disabled={code.length < 6}>
          Verify & continue
        </Button>
        <Button kind="tertiary" type="button" onClick={onCancel}>
          {cancelLabel}
        </Button>
      </div>
    </form>
  );
}
